import * as React from "react"
import PropTypes from "prop-types"
import { Link, useStaticQuery, graphql } from "gatsby"
import Logo from "../images/Logotyp.svg"
import { ImSearch } from "react-icons/im"
import { Search } from "./Search"
import { useState } from "react"
import Headroom from "react-headroom"

const HeaderLink = ({ children, to }) => {
  const path = typeof window !== "undefined" ? window.location.pathname : ""

  const active = path === to
  return (
    <Link
      to={to}
      className={`uppercase font-medium tracking-wide text-sm py-4 sm:py-7 border-b-4 border-b-transparent hover:border-b-gray-900 whitespace-nowrap ${
        active
          ? "border-b-gray-900 group-hover:border-b-transparent hover:!border-b-gray-900"
          : ""
      }`}
    >
      {children}
    </Link>
  )
}

const Header = ({ setShowSearch }) => {
  const {
    wpMenu: {
      menuItems: { nodes: menuItems },
    },
  } = useStaticQuery(graphql`
    query TopMenyQuery {
      wpMenu(name: { eq: "Top menu" }) {
        menuItems {
          nodes {
            id
            parentId
            label
            url
            path
            order
          }
        }
      }
    }
  `)

  return (
    <Headroom style={{ zIndex: 20 }} className="relative">
      <header className=" pl-7 sm:px-7 md:px-12 z-50 bg-white shadow-lg">
        <div className="max-w-screen-xl mx-auto flex sm:justify-between sm:items-center flex-col sm:flex-row ">
          <Link to="/" className="py-6 sm:py-0">
            <img src={Logo} className="h-12" />
          </Link>
          <div className="flex flex-row items-center space-x-9">
            <div className="flex items-center sm:justify-end space-x-9 w-full group overflow-x-auto sm:overflow-x-hidden pr-7 sm:pr-0">
              {menuItems
                .sort((a, b) => (a.order < b.order ? -1 : 1))
                .map(item => (
                  <HeaderLink to={item.path} key={item.path}>
                    {item.label}
                  </HeaderLink>
                ))}
            </div>
            <ImSearch
              className="h-7 w-7 sm:h-6 sm:w-6 absolute top-12 right-12 translate-x-1/2 -translate-y-1/2 sm:static sm:translate-x-0 sm:-translate-y-1 cursor-pointer text-gray-900"
              onClick={() => setShowSearch(true)}
            ></ImSearch>
          </div>
        </div>
      </header>
    </Headroom>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
